<aside id="layout-menu " class="layout-menu menu-vertical menu bg-menu-theme">
  <div class="app-brand demo">
    <a href="javascript:void(0);" class="app-brand-link ">
      <!-- <button type="button" class=" btn-navy btn-sm" (click)="togglecollapsedScreen(isCollasepedflag)">
      <i class="ti ti-menu-2 ti-md t-menu"></i>
    </button> -->
    <!-- <i
    class="ti ti-menu-2 ti-md t-menu"
    (click)="togglecollapsedScreen(isCollasepedflag)"
    >
  </i>  -->

  <!-- <span class="app-brand-text demo menu-text fw-bold">TATA</span> -->
  <!-- <i
  class="ti ti-menu-2 ti-md t-menu"
  (click)="togglecollapsedScreen(isCollasepedflag)"
></i> -->
</a>
<!-- ti ti-menu-2 ti-md t-menu d-block d-md-none ng-star-inserted -->
<a
  href="javascript:void(0);"
  class="layout-menu-toggle menu-link text-large ms-auto"
  >
  <i
    class="ti ti-x ti-md align-middle d-xl-none"
    (click)="detectMobileView(false)"
  ></i>
</a>
</div>
<div class="menu-inner-shadow"></div>
<!-- menu-inner py-1 ps ps--active-y ps--scrolling-y -->
<ul class="menu-inner py-1 ps--scrolling-y">
  @for (item of MENUITEMS; track item?.id ?? $index) {
    @if (item?.HeaderTitle) {
      <li class="menu-header small">
        <span class="menu-header-text" data-i18n="Apps & Pages">{{
          item?.HeaderTitle
        }}</span>
      </li>
    }
    @if (item?.title) {
      <li
        class="menu-item"
          [ngClass]="{
            active: item?.active == true,
            open: item?.isOpen
          }"
        (click)="getActivemenu(item)"
        >
        <a
          [routerLink]="item?.path"
          class="menu-link"
          [ngClass]="item?.type == 'sub' ? 'menu-toggle' : ''"
          >
          <!-- <i class="menu-icon tf-icons ti" [ngClass]="item?.icon"></i> -->
          <img class="img-icon" [src]="item?.imgpath" />
          <div
            data-i18n="Dashboards"
            >
            {{ item?.title }}
          </div>
          <!-- <div class="badge bg-danger rounded-pill ms-auto">5</div> -->
        </a>
        <!-- <ul class="menu-sub" *ngFor="let subitem of item?.children">
        <li
          class="menu-item"
          [ngClass]="subitem?.active ? 'active' : ''"
          (click)="getActiveChild(item, subitem, $event)"
          >
          <a class="menu-link" [routerLink]="subitem?.path">
            <div data-i18n="Analytics">{{ subitem?.title }}</div>
          </a>
        </li>
      </ul> -->
      @for (subitem of item?.children; track subitem?.id ?? $index) {
        <ul class="menu-sub">
          <li
            class="menu-item"
            [ngClass]="subitem?.active ? 'active' : ''"
            (click)="navigateTo(subitem.path, item, subitem, $event)"
            >
            <a class="menu-link" [routerLink]="subitem?.path">
              <div data-i18n="Analytics">{{ subitem?.title }}</div>
            </a>
          </li>
        </ul>
      }
    </li>
  }
}
</ul>
<div class="user-wrapper d-flex align-items-center p-2 d-none">
  <!-- Profile Image -->
  <img
    src="/assets/img/avatars/1.png"
    alt="Profile Picture"
    class="rounded-circle profile-img me-3"
    />

  <!-- User Information -->
  @if (isCollapse==false) {
    <div>
      <h5 class="mb-0 mb-user">{{ username || "Guest" }}</h5>
      <div class="mb-user-id">
        {{ userType || "User" | uppercase }}-{{ subuserType }}
      </div>
    </div>
  }
</div>
</aside>
